import type { Degree, Margins } from "@pdfking/math"
import { RotateMarginsLeft, Round } from "@pdfking/math"
import { QUARTER_TURN } from "@pdfking/math/constants"

/** A turn as the quarter it stands at: 0, 90, 180 or 270, whichever way round
 * it was counted. */
export const QuarterTurn = (rotation: Degree): Degree =>
  ((((Round(rotation / QUARTER_TURN) % 4) + 4) % 4) * QUARTER_TURN) as Degree

/**
 * Margins of something turned `rotation` counter-clockwise, read on the sheet:
 * each quarter hands every edge to the next one round. A negative turn reads
 * them back into the thing's own frame.
 */
export const TurnMargins = <T>(margins: Margins<T>, rotation: Degree): Margins<T> => {
  let turned = margins
  for (let i = 0; i < QuarterTurn(rotation) / QUARTER_TURN; i++) turned = RotateMarginsLeft(turned)
  return turned
}
